:host {
  .hide {
    display: none !important;
  }

  .required-field {
    display: none;
    color: #e91e63;
    color: var(--red);
    margin-bottom: 10px;
    font-size: 11px;
    margin-left: 5px;
    margin-top: 2px;

    &.show {
      display: block;
    }
  }

  .modal {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    background: white;
    background: var(--bg-primary);
    padding: 20px;
    box-sizing: border-box;
    left: 10%;
    width: 80%;
    border-radius: 17px;

    &__flag {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      img {
        width: 25px;
        margin: 0 10px;
      }
    }

    &__text,
    &__action {
      color: #333;
      color: var(--font-primary);
      font-size: 15px;
      letter-spacing: 0;
      line-height: 20px;
    }

    &__action {
      margin-top: 20px;

      button {
        background-color: #0098ff;
        background-color: var(--blue);
        color: white;
        padding: 15px;
        border-radius: 4px;
        border: none;
        cursor: pointer;

        &:focus {
          outline: none;
        }

        &:hover {
          transition: background 0.3s;
          background: #007ee2;
          background: var(--blue-hover);
        }

        &.disabled {
          opacity: 0.5;

          &:hover {
            background-color: #0098ff;
            background-color: var(--blue);
            color: white;
          }
        }
      }
    }
  }

  .modal-bg {
    background: black;
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    opacity: 0.4;
  }

  .jelastic__description {
    color: #333333;
    color: var(--font-primary);
    font-size: 15px;
    letter-spacing: 0;
    line-height: 24px;
  }

  .question {
    margin-top: 15px;
    padding: 15px 20px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background-color: #fff;
    background-color: var(--bg-primary);

    &.required {
      border-color: #e91e63;
      border-color: var(--red);
    }

    &__title {
      color: #666666;
      color: var(--font-secondary);
      font-size: 15px;
      letter-spacing: 0;
      line-height: 24px;
    }

    &__choice {
      margin-top: 15px;

      button {
        background-color: #fff;
        background-color: var(--bg-primary);
        color: #0098ff;
        color: var(--blue);
        padding: 15px;
        border-radius: 4px;
        border: 1px solid #0098ff;
        cursor: pointer;
        width: 100%;
        max-width: 150px;
        margin-right: 10px;
        margin-bottom: 10px;

        &:focus {
          outline: none;
        }

        &:hover,
        &.selected {
          transition: background 0.3s;
          background-color: #0098ff;
          background-color: var(--blue);
          color: white;
        }

        &.disabled {
          opacity: 0.5;

          &:hover {
            background-color: #0098ff;
            background-color: var(--blue);
            color: white;
          }
        }

        &:last-child {
          margin-right: 0;
        }
      }

      &--vertical {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        button {
          width: auto;
          max-width: inherit;
          margin-right: 0;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .select {
    margin-top: 15px;
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 100px;
    background-color: #fff;
    background-color: var(--bg-tooltip);
    color: #333333;
    color: var(--font-primary);
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    padding: 10px;
    box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.15);
    margin-left: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    line-height: 14px;
  }

  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    top: 100%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    border-color: var(--bg-tooltip) transparent transparent transparent;
    right: 50%;
    transform: translateX(50%);
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  .mail-product {
    margin-bottom: 10px;
    padding-bottom: 10px;

    .input-subject {
      margin-bottom: 50px;
    }

    select,
    input,
    textarea {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #e0e0e0;
      border: 1px solid var(--divider);
      border-radius: 4px;
      padding: 15px;
      font-size: 15px;
      color: #666;
      color: var(--font-secondary);
      margin-bottom: 10px;
      font-family: Roboto, sans-serif;
      background: #fff;
      background: var(--bg-primary);

      &:focus {
        outline: none;
      }
    }

    select {
      background-image:
        linear-gradient(45deg, transparent 50%, #333 50%),
        linear-gradient(135deg, #333 50%, transparent 50%),
        linear-gradient(to right, transparent, transparent);
      background-image:
        linear-gradient(45deg, transparent 50%, var(--font-primary) 50%),
        linear-gradient(135deg, var(--font-primary) 50%, transparent 50%),
        linear-gradient(to right, transparent, transparent);
      background-position:
        calc(100% - 20px) calc(1em + 2px),
        calc(100% - 15px) calc(1em + 2px);
      background-size:
        5px 5px,
        5px 5px;
      background-repeat: no-repeat;
      box-sizing: border-box;
      -webkit-appearance: none;
      -moz-appearance: none;
    }

    textarea {
      min-height: 150px;
      resize: none;

      &::placeholder,
      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        opacity: 1; /* Firefox */
        color: #666;
        color: var(--font-secondary);
      }
    }

    input {
      color: #333;
      color: var(--font-primary);

      &::placeholder {
        color: #666;
        color: var(--font-secondary);
        opacity: 1; /* Firefox */
      }

      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        color: #666;
        color: var(--font-secondary);
      }
    }

    .mail-product-files {
      margin-top: 15px;

      &__title {
        color: #333333;
        color: var(--font-primary);
        font-size: 15px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 21px;
      }

      &__description {
        color: #666666;
        color: var(--font-secondary);
        font-size: 12px;
        letter-spacing: 0;
        line-height: 14px;
        margin-bottom: 20px;
      }

      &__files {
        .file-container {
          position: relative;
          display: flex;
          border: 2px dashed #e0e0e0;
          border: 2px dashed var(--divider);
          padding: 15px 60px 15px 15px;
          margin-bottom: 20px;
          height: 100%;
          flex-wrap: wrap;

          img {
            width: 18px;
            height: 18px;
            object-fit: contain;
            margin-right: 20px;
            filter: invert(9%) sepia(5%) saturate(560%) hue-rotate(201deg) brightness(92%)
              contrast(94%);
            filter: var(--icon-bg-primary--invert);
          }

          a {
            text-decoration: none;
            color: #0098ff;
            color: var(--blue);
          }

          .file {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: calc(20% - 10px);
            text-align: center;
            margin-right: 5px;
            margin-left: 5px;
            margin-bottom: 10px;
            margin-top: 10px;
            box-sizing: border-box;

            img {
              width: 22px;
              height: 22px;
              margin-right: 0;
              margin-bottom: 5px;
            }

            &__close {
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              right: 0;
              top: -10px;

              img {
                cursor: pointer;
                position: relative;
                width: 12px;
                height: 12px;
                margin: 0;
                object-fit: contain;
                filter: invert(19%) sepia(16%) saturate(0%) hue-rotate(157deg) brightness(94%)
                  contrast(95%);
                filter: var(--icon-font-primary);
              }
            }

            &__title {
              color: #333333;
              color: var(--font-primary);
              font-size: 12px;
              letter-spacing: 0;
              line-height: 16px;
              text-overflow: ellipsis;
              width: 80px;
              white-space: nowrap;
              overflow: hidden;
            }
          }

          .upload {
            background: #0098ff;
            background: var(--blue);
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            color: var(--font-primary--invert);
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
            cursor: pointer;

            &:hover {
              transition: background 0.3s;
              background: #007ee2;
              background: var(--blue-hover);
            }
          }
        }

        &--hover {
          .file-container {
            border-color: #0098ff;
            border-color: var(--blue);
          }
        }
      }

      &__info {
        display: flex;
        border-radius: 4px;
        background-color: #0098ff;
        background-color: var(--blue);
        color: white;
        padding: 15px;
        box-sizing: border-box;
        margin-bottom: 30px;

        img {
          width: 20px;
          height: 20px;
          object-fit: contain;
          margin-right: 10px;
          filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
            contrast(105%);
          filter: var(--icon-white);
        }

        p {
          margin: 0;
        }
      }
    }

    .mail-product-action {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      .g-recaptcha {
        margin-bottom: 20px;
      }

      button {
        background-color: #0098ff;
        background-color: var(--blue);
        color: white;
        padding: 15px;
        border-radius: 4px;
        border: none;
        cursor: pointer;

        &:focus {
          outline: none;
        }

        &:hover {
          transition: background 0.3s;
          background: #007ee2;
          background: var(--blue-hover);
        }

        &.disabled {
          opacity: 0.5;

          &:hover {
            background-color: #0098ff;
            background-color: var(--blue);
            color: white;
          }
        }
      }
    }
    &--error,
    &--success {
      height: 100%;
    }

    /* -------------------------------------------------------------------------- */
    /*                                FULL VERSION                                */
    /* -------------------------------------------------------------------------- */

    &.mail-product--full {
      background: white;
      background: var(--bg-primary);
      padding: 30px;
      box-sizing: border-box;
      border-radius: 6px;

      .first-row {
        display: flex;
        justify-content: center;

        .select-service {
          &:first-child {
            margin-right: 10px;
          }

          &:last-child {
            margin-left: 10px;
          }
        }
      }
    }

    /* -------------------------------------------------------------------------- */
    /*                           SCROLL IN FULL VERSION                           */
    /* -------------------------------------------------------------------------- */
    &.mail-product--scroll {
      textarea,
      .input-subject {
        margin-bottom: 20px;
      }
    }
  }

  .input,
  .textarea,
  .select {
    margin-top: 15px;

    &.required {
      border-color: #e91e63;
      border-color: var(--red);
      border: 1px solid;
      border-radius: 4px;
    }

    input,
    textarea,
    select {
      margin-bottom: 0;
    }
  }

  .error {
    display: block;
    margin-bottom: 20px;
    color: #fb472e;
    color: var(--danger);

    .error-file {
      display: block;
      margin-bottom: 5px;

      strong {
        font-weight: 500;
      }
    }
  }
}
